import React from 'react';

import { AutocompleteAddressInput } from 'components/autocomplete-address-input';
import { useGeolocation } from 'state/geolocation';
import { t } from 'state/intl/translations';

import { ISearchBarProps } from './types';

export const SearchBar = ({ defaultValue, onAddressSelected }: ISearchBarProps) => {
  const { resetCoordinatesManual, setManualAddress, manualAddress } = useGeolocation();

  return (
    <AutocompleteAddressInput
      required
      value={manualAddress || defaultValue}
      onInputValueChange={value => {
        setManualAddress(value?.toString() || '');
        if (!value) {
          resetCoordinatesManual();
        }
      }}
      onAddressSelected={async (address, placeId, placeData, sessionToken) => {
        onAddressSelected?.(address, placeId, placeData, sessionToken);
      }}
      label={t('yourAddress')}
      testID="storelocator-autocomplete"
      inputCustomProps={{ backgroundColor: 'white' }}
    />
  );
};
